<!--  Exhaust fan And Humidifiers And Air handlar  -->
<div class="row"
    *ngIf="isAem  && isSalePriceGreaterThan150">
    <div class="col-sm-6 pe-0 column">
        <div class="col-sm-12">
            <div class="container-fluid h-100">
                <fieldset class="border rounded-3 p-1" *ngIf="exhaustFansFormGroup"
                    [formGroup]="exhaustFansFormGroup" [class.section-disabled]="isSectionFieldsetDisabled('exhaustFansFormGroup')" trackChanges>
                    <legend class="float-none w-auto   font-size-13">
                        {{'REVIEW_SOL_CHECKLIST_TAB.EXHAUST_FANS.TITLE' |translate}} <si-check-box  [isReadMode]="false" [isDisabled]="isDisabled" [isChecked]="isSectionChecked('exhaustFansFormGroup')" (change)="onSectionToggle('exhaustFansFormGroup', $event)"></si-check-box></legend>
                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.EXHAUST_FANS.NUMBER_OF_EXHAUST_FANS' |translate}}
                            </mat-label>
                        </div>
                        <div class="col-sm-6">
                            <app-si-form-field formControlName="numberOfExhaustFans"  [type]="'number'" [maxlength]="4" [max]="9999"
                                [isReadMode]="isReadMode" [isDisabled]="isDisabled">
                            </app-si-form-field>
                        </div>
                    </div>
                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.EXHAUST_FANS.MANUFACTURER'
                                |translate}}</mat-label>
                        </div>
                        <div class="col-sm-6 break-word">
                            <app-si-form-field formControlName="manufacturer"  [maxlength]="40"
                                [isReadMode]="isReadMode" [isDisabled]="isDisabled">
                            </app-si-form-field>
                        </div>
                    </div>
                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.EXHAUST_FANS.UNITS_CONTROLS_FURNISHED_BY'
                                |translate}} </mat-label>
                        </div>
                        <div class="col-sm-6">
                            <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                                formControlName="unitsControlsFurnishedBy" [disabled]="isReadMode">
                                <si-radio-button [displayText]="'SIEMENS' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(exhaustFansFormGroup, 'unitsControlsFurnishedBy')">
                                </si-radio-button>
                                <si-radio-button [displayText]="'OTHER' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(exhaustFansFormGroup, 'unitsControlsFurnishedBy')">
                                </si-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.EXHAUST_FANS.UNITS_CONTROLS_INSTALLED_BY'
                                |translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                                formControlName="unitsControlsInstalledBy" [disabled]="isReadMode">
                                <si-radio-button [displayText]="'SIEMENS' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(exhaustFansFormGroup, 'unitsControlsInstalledBy')">
                                </si-radio-button>
                                <si-radio-button [displayText]="'OTHER' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(exhaustFansFormGroup, 'unitsControlsInstalledBy')">
                                </si-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.EXHAUST_FANS.UNITS_CONTROLS_WIRED_BY'
                                |translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                                formControlName="unitsControlsWiredBy" [disabled]="isReadMode">
                                <si-radio-button [displayText]="'SIEMENS' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(exhaustFansFormGroup, 'unitsControlsWiredBy')">
                                </si-radio-button>
                                <si-radio-button [displayText]="'OTHER' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(exhaustFansFormGroup, 'unitsControlsWiredBy')">
                                </si-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                </fieldset>
                <fieldset class="border rounded-3 p-1" *ngIf="!costReviewExhaustFans?.isExhaustFansApplicable && isReadMode">
                    <legend class="float-none w-auto   font-size-13">
                        {{'REVIEW_SOL_CHECKLIST_TAB.EXHAUST_FANS.TITLE' |translate}} </legend>
                    <div class="row bottomPadding">
                        <div class="col-sm-12">
                            <span> {{'REVIEW_SOL_CHECKLIST_TAB.SECTION_NOT_APPLICABLE' | translate}}</span>
                        </div>
                    </div>
                </fieldset>
            </div>
        </div>
        <div class="col-sm-12">
            <div class="container-fluid h-100">
                <fieldset class="border rounded-3 p-1 h-100" *ngIf="airHandlersFormGroup"
                    [formGroup]="airHandlersFormGroup" [class.section-disabled]="isSectionFieldsetDisabled('airHandlersFormGroup')" trackChanges>
                    <legend class="float-none w-auto   font-size-13">
                        {{'REVIEW_SOL_CHECKLIST_TAB.AIR_HANDLERS.TITLE'| translate}} <si-check-box  [isReadMode]="false" [isDisabled]="isDisabled" [isChecked]="isSectionChecked('airHandlersFormGroup')" (change)="onSectionToggle('airHandlersFormGroup', $event)"></si-check-box></legend>
                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.AIR_HANDLERS.NUMBER_OF_AIR_HANDLER_UNITS'|
                                translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <app-si-form-field formControlName="numberOfAirHandlerUnits"  [type]="'number'" [maxlength]="4" [max]="9999"
                                [isReadMode]="isReadMode" [isDisabled]="isDisabled">
                            </app-si-form-field>
                        </div>
                    </div>
                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.AIR_HANDLERS.MANUFACTURER'|
                                translate}}</mat-label>
                        </div>
                        <div class="col-sm-6 break-word">
                            <app-si-form-field formControlName="manufacturer"  [maxlength]="40"
                                [isReadMode]="isReadMode" [isDisabled]="isDisabled">
                            </app-si-form-field>
                        </div>
                    </div>
                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.AIR_HANDLERS.UNITS_CONTROLS_FURNISHED_BY'|
                                translate}} </mat-label>
                        </div>
                        <div class="col-sm-6">
                            <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                                formControlName="unitsControlsFurnishedBy" [disabled]="isReadMode">
                                <si-radio-button [displayText]="'SIEMENS' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(airHandlersFormGroup, 'unitsControlsFurnishedBy')">
                                </si-radio-button>
                                <si-radio-button [displayText]="'OTHER' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(airHandlersFormGroup, 'unitsControlsFurnishedBy')">
                                </si-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.AIR_HANDLERS.UNITS_CONTROLS_INSTALLED_BY'|
                                translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                                formControlName="unitsControlsInstalledBy" [disabled]="isReadMode">
                                <si-radio-button [displayText]="'SIEMENS' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(airHandlersFormGroup, 'unitsControlsInstalledBy')">
                                </si-radio-button>
                                <si-radio-button [displayText]="'OTHER' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(airHandlersFormGroup, 'unitsControlsInstalledBy')">
                                </si-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.AIR_HANDLERS.UNITS_CONTROLS_WIRED_BY'|
                                translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                                formControlName="unitsControlsWiredBy" [disabled]="isReadMode">
                                <si-radio-button [displayText]="'SIEMENS' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(airHandlersFormGroup, 'unitsControlsWiredBy')">
                                </si-radio-button>
                                <si-radio-button [displayText]="'OTHER' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(airHandlersFormGroup, 'unitsControlsWiredBy')">
                                </si-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.AIR_HANDLERS.SPECIAL_SENSORS_REQUIRED'|
                                translate}} </mat-label>
                        </div>
                        <div class="col-sm-6">
                            <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                                formControlName="specialSensorsRequired" [disabled]="isReadMode">
                                <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(airHandlersFormGroup, 'specialSensorsRequired')">
                                </si-radio-button>
                                <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(airHandlersFormGroup, 'specialSensorsRequired')">
                                </si-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label class="margin-left-10">{{'REVIEW_SOL_CHECKLIST_TAB.AIR_HANDLERS.NUMBER_OF_FANS'|
                                translate}} </mat-label>
                        </div>
                        <div class="col-sm-6">
                            <app-si-form-field formControlName="numberOfFans"  [type]="'number'" [maxlength]="2" [max]="99"
                                [isReadMode]="isReadMode" [isDisabled]="isDisabled || !isControlValueEqualToTranslation(airHandlersFormGroup,'specialSensorsRequired','YES')">
                            </app-si-form-field>
                        </div>
                    </div>
                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label class="margin-left-10">{{'REVIEW_SOL_CHECKLIST_TAB.AIR_HANDLERS.DESCRIPTION'|
                                translate}} </mat-label>
                        </div>
                        <div class="col-sm-6 break-word">
                            <app-si-form-field formControlName="description"  [maxlength]="40"
                                [isReadMode]="isReadMode" [isDisabled]="isDisabled || !isControlValueEqualToTranslation(airHandlersFormGroup,'specialSensorsRequired','YES')">
                            </app-si-form-field>
                        </div>
                    </div>
                </fieldset>
                <fieldset class="border rounded-3 p-1" *ngIf="!costReviewAirHandler?.isAirHandlersApplicable && isReadMode">
                    <legend class="float-none w-auto   font-size-13">
                        {{'REVIEW_SOL_CHECKLIST_TAB.AIR_HANDLERS.TITLE'| translate}}</legend>
                    <div class="row bottomPadding">
                        <div class="col-sm-12">
                            <span> {{'REVIEW_SOL_CHECKLIST_TAB.SECTION_NOT_APPLICABLE' | translate}}</span>
                        </div>
                    </div>
                </fieldset>
            </div>
        </div>
    </div>
    <div class="col-sm-6 ps-0">
        <div class="col-sm-12">
            <div class="container-fluid">
                <fieldset class="border rounded-3 p-1" *ngIf="humidifiersFormGroup"
                    [formGroup]="humidifiersFormGroup" [class.section-disabled]="isSectionFieldsetDisabled('humidifiersFormGroup')" trackChanges>
                    <legend class="float-none w-auto   font-size-13">
                        {{'REVIEW_SOL_CHECKLIST_TAB.HUMIDIFIERS.TITLE' | translate}}  <si-check-box  [isReadMode]="false" [isDisabled]="isDisabled" [isChecked]="isSectionChecked('humidifiersFormGroup')" (change)="onSectionToggle('humidifiersFormGroup', $event)"></si-check-box></legend>
                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.HUMIDIFIERS.NUMBER_OF_HUMIDIFIERS' |
                                translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <app-si-form-field formControlName="numberOfHumidifires"  [type]="'number'" [maxlength]="4" [max]="9999"
                                [isReadMode]="isReadMode" [isDisabled]="isDisabled">
                            </app-si-form-field>
                        </div>
                    </div>
                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.HUMIDIFIERS.MANUFACTURER' |
                                translate}}</mat-label>
                        </div>
                        <div class="col-sm-6 break-word">
                            <app-si-form-field formControlName="manufacturer"  [maxlength]="40"
                                [isReadMode]="isReadMode" [isDisabled]="isDisabled">
                            </app-si-form-field>
                        </div>
                    </div>
                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.HUMIDIFIERS.UNITS_CONTROLS_FURNISHED_BY' |
                                translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                                formControlName="unitsControlsFurnishedBy" [disabled]="isReadMode">
                                <si-radio-button [displayText]="'SIEMENS' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(humidifiersFormGroup, 'unitsControlsFurnishedBy')">
                                </si-radio-button>
                                <si-radio-button [displayText]="'OTHER' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(humidifiersFormGroup, 'unitsControlsFurnishedBy')">
                                </si-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.HUMIDIFIERS.UNITS_CONTROLS_INSTALLED_BY' |
                                translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                                formControlName="unitsControlsInstalledBy" [disabled]="isReadMode">
                                <si-radio-button [displayText]="'SIEMENS' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(humidifiersFormGroup, 'unitsControlsInstalledBy')">
                                </si-radio-button>
                                <si-radio-button [displayText]="'OTHER' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(humidifiersFormGroup, 'unitsControlsInstalledBy')">
                                </si-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.HUMIDIFIERS.UNITS_CONTROLS_WIRED_BY' |
                                translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                                formControlName="unitsControlsWiredBy" [disabled]="isReadMode">
                                <si-radio-button [displayText]="'SIEMENS' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(humidifiersFormGroup, 'unitsControlsWiredBy')">
                                </si-radio-button>
                                <si-radio-button [displayText]="'OTHER' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(humidifiersFormGroup, 'unitsControlsWiredBy')">
                                </si-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                </fieldset>
                <fieldset class="border rounded-3 p-1" *ngIf="!costReviewHumidiFires?.isHumidifiersApplicable && isReadMode">
                    <legend class="float-none w-auto   font-size-13">
                        {{'REVIEW_SOL_CHECKLIST_TAB.HUMIDIFIERS.TITLE' | translate}} </legend>
                    <div class="row bottomPadding">
                        <div class="col-sm-12">
                            <span> {{'REVIEW_SOL_CHECKLIST_TAB.SECTION_NOT_APPLICABLE' | translate}}</span>
                        </div>
                    </div>
                </fieldset>
            </div>
        </div>
    </div>
</div>

<!--- Execution Schedule , Network and Retrofit Considerations-->
<div class="row fit-to-row-height">
    <div class="col-sm-6 pe-0 ps-0"
        *ngIf="(isSecurity && executionScheduleFormGroup)">
        <div class="container-fluid h-100">
            <fieldset class="border rounded-3 p-1 h-100" *ngIf="(isSecurity && executionScheduleFormGroup)"
                [formGroup]="executionScheduleFormGroup" [class.section-disabled]="isSectionFieldsetDisabled('executionScheduleFormGroup')" trackChanges>
                <legend class="float-none w-auto   font-size-13">
                    <si-check-box  [isReadMode]="false" [isDisabled]="isDisabled" [isChecked]="isSectionChecked('executionScheduleFormGroup')" (change)="onSectionToggle('executionScheduleFormGroup', $event)"></si-check-box>
                {{'REVIEW_SOL_CHECKLIST_TAB.EXECUTION_SCHEDULE.TITLE' | translate}}
                </legend>

                <div class="row bottomPadding" *ngIf="(isSecurity)">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.EXECUTION_SCHEDULE.PHASED_INSTALLATION_OCCUPANCY' |
                            translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <mat-radio-group class="radio-group d-flex radio-btns" formControlName="phasedInstallation"  [disabled]="isDisabled">
                            <si-radio-button [selectedValue]="formControlsValueForString(executionScheduleFormGroup, 'phasedInstallation')"
                                [displayText]="'YES' | translate" 
                                [isReadMode]="isReadMode"
                                [isDisabled]="isDisabled">
                            </si-radio-button>
                            <si-radio-button [selectedValue]="formControlsValueForString(executionScheduleFormGroup, 'phasedInstallation')"
                                [displayText]="'NO' | translate" 
                                [isReadMode]="isReadMode"
                                [isDisabled]="isDisabled">
                            </si-radio-button>
                        </mat-radio-group>
                    </div>
                </div>


                <div class="row bottomPadding" *ngIf="(isSecurity)">
                    <div class="col-sm-6">
                        <mat-label class="margin-left-10">
                            {{'REVIEW_SOL_CHECKLIST_TAB.EXECUTION_SCHEDULE.DESCRIBE_PHASING_CONSIDERATIONS' |
                            translate}}
                        </mat-label>
                    </div>
                    <div class="col-sm-6 mb-2">
                        <si-text-area formControlName="describePhasingConsiderations" [isReadMode]="isReadMode" [isDisabled]="isDisabled || !isControlValueEqualToTranslation(executionScheduleFormGroup, 'phasedInstallation', 'YES')"></si-text-area>
                    </div>
                </div>

                <div class="row bottomPadding"
                    *ngIf="(isSecurity)">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.EXECUTION_SCHEDULE.PROJECT_SCHEDULE_PUBLISHED' |
                            translate}}</mat-label><br>
                        <mat-label *ngIf="(isSecurity)"
                            class="margin-left-10 font-style-italic">
                            ({{'REVIEW_SOL_CHECKLIST_TAB.EXECUTION_SCHEDULE.NOT_APPROACH_AGGRESSIVELY' | translate}})
                        </mat-label>
                    </div>
                    <div class="col-sm-6">
                        <mat-radio-group class="radio-group d-flex radio-btns margin-top-10" formControlName="projectSchedulePublished"  [disabled]="isDisabled">
                            <si-radio-button [selectedValue]="formControlsValueForString(executionScheduleFormGroup, 'projectSchedulePublished')"
                                [displayText]="'YES' | translate" 
                                [isReadMode]="isReadMode"
                                [isDisabled]="isDisabled">
                            </si-radio-button>
                            <si-radio-button [selectedValue]="formControlsValueForString(executionScheduleFormGroup, 'projectSchedulePublished')"
                                [displayText]="'NO' | translate" 
                                [isReadMode]="isReadMode"
                                [isDisabled]="isDisabled">
                            </si-radio-button>
                        </mat-radio-group>
                    </div>
                </div>


                <div class="row bottomPadding" *ngIf="(isSecurity)">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.EXECUTION_SCHEDULE.OFFICE_TECHNICAL_COMPETENCIES' |
                            translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <mat-radio-group class="radio-group d-flex radio-btns margin-top-10" formControlName="officeTechnicalCompetencies"  [disabled]="isDisabled">
                            <si-radio-button [selectedValue]="formControlsValueForString(executionScheduleFormGroup, 'officeTechnicalCompetencies')"
                                [displayText]="'YES' | translate" 
                                [isReadMode]="isReadMode"
                                [isDisabled]="isDisabled">
                            </si-radio-button>
                            <si-radio-button [selectedValue]="formControlsValueForString(executionScheduleFormGroup, 'officeTechnicalCompetencies')"
                                [displayText]="'NO' | translate" 
                                [isReadMode]="isReadMode"
                                [isDisabled]="isDisabled">
                            </si-radio-button>
                        </mat-radio-group>
                    </div>
                </div>

                <div class="row bottomPadding" *ngIf="(isSecurity)">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.EXECUTION_SCHEDULE.LOCAL_OFFICE_STAFFED' |
                            translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <mat-radio-group class="radio-group d-flex radio-btns margin-top-10" formControlName="localOfficeStaffed"  [disabled]="isDisabled">
                            <si-radio-button [selectedValue]="formControlsValueForString(executionScheduleFormGroup, 'localOfficeStaffed')"
                                [displayText]="'YES' | translate" 
                                [isReadMode]="isReadMode"
                                [isDisabled]="isDisabled">
                            </si-radio-button>
                            <si-radio-button [selectedValue]="formControlsValueForString(executionScheduleFormGroup, 'localOfficeStaffed')"
                                [displayText]="'NO' | translate" 
                                [isReadMode]="isReadMode"
                                [isDisabled]="isDisabled">
                            </si-radio-button>
                        </mat-radio-group>
                    </div>
                </div>

                <div class="row bottomPadding"
                    *ngIf="(isSecurity)">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.EXECUTION_SCHEDULE.SPECIAL_TAGGING_REQUIREMENTS' |
                            translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <mat-radio-group class="radio-group d-flex radio-btns margin-top-10" formControlName="specialTaggingRequirements"  [disabled]="isDisabled">
                            <si-radio-button [selectedValue]="formControlsValueForString(executionScheduleFormGroup, 'specialTaggingRequirements')"
                                [displayText]="'YES' | translate" 
                                [isReadMode]="isReadMode"
                                [isDisabled]="isDisabled">
                            </si-radio-button>
                            <si-radio-button [selectedValue]="formControlsValueForString(executionScheduleFormGroup, 'specialTaggingRequirements')"
                                [displayText]="'NO' | translate" 
                                [isReadMode]="isReadMode"
                                [isDisabled]="isDisabled">
                            </si-radio-button>
                        </mat-radio-group>
                    </div>
                </div>


                <div class="row bottomPadding"
                    *ngIf="(isSecurity) && formControlsValueForString(executionScheduleFormGroup,'specialCutoverRequirements')">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.EXECUTION_SCHEDULE.SPECIAL_CUTOVER_REQUIREMENTS' |
                            translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <mat-radio-group  class="radio-group d-flex radio-btns margin-top-10" formControlName="specialCutoverRequirements"  [disabled]="isDisabled">
                            <si-radio-button [selectedValue]="formControlsValueForString(executionScheduleFormGroup, 'specialCutoverRequirements')"
                                [displayText]="'YES' | translate" 
                                [isReadMode]="isReadMode"
                                [isDisabled]="isDisabled">
                            </si-radio-button>
                            <si-radio-button [selectedValue]="formControlsValueForString(executionScheduleFormGroup, 'specialCutoverRequirements')"
                                [displayText]="'NO' | translate" 
                                [isReadMode]="isReadMode"
                                [isDisabled]="isDisabled">
                            </si-radio-button>
                        </mat-radio-group> 
                    </div>
                </div>
            </fieldset>
            <fieldset class="border rounded-3 p-1" *ngIf="!(isSecurity  && costReviewSecurityEnUsExecutionSchedule?.isExecutionScheduleChecked) && isReadMode">
                <legend class="float-none w-auto   font-size-13">
                    {{'REVIEW_SOL_CHECKLIST_TAB.EXECUTION_SCHEDULE.TITLE' | translate}}</legend>
                <div class="row bottomPadding">
                    <div class="col-sm-12">
                        <span>{{'REVIEW_SOL_CHECKLIST_TAB.SECTION_NOT_APPLICABLE' | translate}}</span>
                    </div>
                </div>
            </fieldset>
        </div>
    </div>

    <div class="col-sm-6 pe-0 ps-0 column"
        *ngIf="(isSecurity) && costReviewSecurityEnUsNetwork">
        <div class="col-sm-12 height-50">
            <div class="container-fluid h-100">
                <fieldset class="border rounded-3 p-1 h-100" *ngIf="securityNetworkFormGroup"
                    [formGroup]="securityNetworkFormGroup" [class.section-disabled]="isSectionFieldsetDisabled('securityNetworkFormGroup')" trackChanges>
                    <legend class="float-none w-auto   font-size-13">
                        {{'REVIEW_SOL_CHECKLIST_TAB.NETWORK.TITLE' | translate}} <si-check-box  [isReadMode]="false" [isDisabled]="isDisabled" [isChecked]="isSectionChecked('securityNetworkFormGroup')" (change)="onSectionToggle('securityNetworkFormGroup', $event)"></si-check-box></legend>
                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.NETWORK.NETWORK_STYLE' | translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <div class="aligned-options-container">
                            <mat-radio-group class="radio-group radio-btns d-flex flex-row margin-top-10" formControlName="networkStyle" [disabled]="isReadMode">
                                <si-radio-button [displayText]="'PEER_TO_PEER' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(securityNetworkFormGroup, 'networkStyle')">
                                </si-radio-button>
                                <si-radio-button [displayText]="'TRANSPONDER' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(securityNetworkFormGroup, 'networkStyle')">
                                </si-radio-button>
                            </mat-radio-group></div>
                        </div>
                    </div>
                    <div class="row bottomPadding">
                        <div class="col-sm-6"></div>
                        <div class="col-sm-6 break-word">
                            <div class="aligned-options-container">
                            <si-check-box-group
                                [options]="networkOptionsArray"
                                [isReadMode]="isReadMode"
                                [isDisabled]="isDisabled"
                                formControlName="networkOptions"
                                [singleRow]="true" [columnsPerRow]="2">
                            </si-check-box-group></div>
                        </div>
                    </div>
                </fieldset>
                <fieldset class="border rounded-3 p-1" *ngIf="!costReviewSecurityEnUsNetwork?.isNetworkChecked && isReadMode">
                    <legend class="float-none w-auto   font-size-13">
                        {{'REVIEW_SOL_CHECKLIST_TAB.NETWORK.TITLE' | translate}}</legend>
                    <div class="row bottomPadding">
                        <div class="col-sm-12">
                            <span>{{'REVIEW_SOL_CHECKLIST_TAB.SECTION_NOT_APPLICABLE' | translate}}</span>
                        </div>
                    </div>
                </fieldset>
            </div>
        </div>

        <div class="col-sm-12 height-50">
            <div class="container-fluid" *ngIf="securityRetrofitFormGroup">
                <fieldset class="border rounded-3 p-1"
                    *ngIf="securityRetrofitFormGroup"
                    [formGroup]="securityRetrofitFormGroup" [class.section-disabled]="isSectionFieldsetDisabled('securityRetrofitFormGroup')" trackChanges>
                    <legend class="float-none w-auto   font-size-13">
                        {{'REVIEW_SOL_CHECKLIST_TAB.RETROFIT_CONSIDERATIONS.TITLE' | translate}} <si-check-box  [isReadMode]="false" [isDisabled]="isDisabled" [isChecked]="isSectionChecked('securityRetrofitFormGroup')" (change)="onSectionToggle('securityRetrofitFormGroup', $event)"></si-check-box></legend>
                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.RETROFIT_CONSIDERATIONS.REUSE_OF_SYSTEM_COMPONENTS' |
                                translate}}</mat-label><br>
                            <mat-label class="margin-left-10 font-style-italic">
                                {{'REVIEW_SOL_CHECKLIST_TAB.RETROFIT_CONSIDERATIONS.IF_YES_VERIFY_EXISTING' |
                                translate}}
                            </mat-label>
                            
                        </div>
                        <div class="col-sm-6">
                            <mat-radio-group class="radio-group radio-btns d-flex margin-top-10" formControlName="reuseSystemComponents" [disabled]="isReadMode">
                                <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(securityRetrofitFormGroup, 'reuseSystemComponents')">
                                </si-radio-button>
                                <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(securityRetrofitFormGroup, 'reuseSystemComponents')">
                                </si-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.RETROFIT_CONSIDERATIONS.EXISTING_WIRING_CAN_BE_REUSED'
                                | translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">

                            <mat-radio-group class="radio-group radio-btns d-flex margin-top-10" formControlName="existingWiringReused" [disabled]="isReadMode">
                                <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(securityRetrofitFormGroup, 'existingWiringReused')">
                                </si-radio-button>
                                <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(securityRetrofitFormGroup, 'existingWiringReused')">
                                </si-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                </fieldset>
                <fieldset class="border rounded-3 p-1"
                    *ngIf="!costReviewSecurityEnUsRetrofitConsiderations?.isRetrofitConsiderationsChecked && isReadMode">
                    <legend class="float-none w-auto   font-size-13">
                        {{'REVIEW_SOL_CHECKLIST_TAB.RETROFIT_CONSIDERATIONS.TITLE' | translate}}</legend>
                    <div class="row bottomPadding">
                        <div class="col-sm-12">
                            <span>{{'REVIEW_SOL_CHECKLIST_TAB.SECTION_NOT_APPLICABLE' | translate}}</span>
                        </div>
                    </div>
                </fieldset>
            </div>
        </div>
    </div>
</div>

<!--- Access Control System-->
<div class="row pe-12 ps-12"
    *ngIf="(isSecurity) && costReviewSecurityEnUsAccessControlSystems">
    <div class="container-fluid">
        <fieldset class="border rounded-3 p-1" *ngIf="accessControlSystemFormGroup"
            [formGroup]="accessControlSystemFormGroup" [class.section-disabled]="isSectionFieldsetDisabled('accessControlSystemFormGroup')" trackChanges>
            <legend class="float-none w-auto   font-size-13">
                {{'REVIEW_SOL_CHECKLIST_TAB.ACCESS_CONTROL_SYSTEM.TITLE' |translate}} <si-check-box  [isReadMode]="false" [isDisabled]="isDisabled" [isChecked]="isSectionChecked('accessControlSystemFormGroup')" (change)="onSectionToggle('accessControlSystemFormGroup', $event)"></si-check-box></legend>
            <div class="row">
                <div class="col-sm-6">
                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.ACCESS_CONTROL_SYSTEM.INTEGRATION_WITH_OTHER_SYSTEM'
                                |translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                                formControlName="integrationWithOtherSystems" [disabled]="isReadMode">
                                <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(accessControlSystemFormGroup, 'integrationWithOtherSystems')">
                                </si-radio-button>
                                <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(accessControlSystemFormGroup, 'integrationWithOtherSystems')">
                                </si-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                    <div class="row bottomPadding access-control-vendor-row">
                        <div class="col-sm-3">
                            <si-check-box formControlName="isNewVendorChecked" [isReadMode]="isReadMode"
                                [isDisabled]="isDisabled || !isSectionChecked('accessControlSystemFormGroup')">
                            </si-check-box>
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.ACCESS_CONTROL_SYSTEM.NEW'
                                |translate}}</mat-label>
                        </div>
                        <div class="col-sm-3">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.ACCESS_CONTROL_SYSTEM.VENDOR'
                                |translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <si-combo-box
                                [inputValue]="formControlsValueForString(accessControlSystemFormGroup,'newVendor')" (inputValueChange)="setFormControlValue(accessControlSystemFormGroup, 'newVendor', $event)"
                                [isReadMode]="isReadMode" [dropDownList]="vendorList"
                                [isDisabled]="isDisabled || !isVendorEnabled('accessControlSystemFormGroup', 'isNewVendorChecked')"></si-combo-box>
                        </div>
                    </div>
                    <div class="row bottomPadding access-control-vendor-row">
                        <div class="col-sm-3">
                            <si-check-box formControlName="isReplacementVendorChecked" [isReadMode]="isReadMode"
                                [isDisabled]="isDisabled || !isSectionChecked('accessControlSystemFormGroup')">
                            </si-check-box>
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.ACCESS_CONTROL_SYSTEM.REPLACEMENT'
                                |translate}}</mat-label>
                        </div>
                        <div class="col-sm-3">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.ACCESS_CONTROL_SYSTEM.VENDOR'
                                |translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <si-combo-box
                                [inputValue]="formControlsValueForString(accessControlSystemFormGroup,'replacementVendor')" (inputValueChange)="setFormControlValue(accessControlSystemFormGroup, 'replacementVendor', $event)"
                                [isReadMode]="isReadMode" [dropDownList]="vendorList"
                                [isDisabled]="isDisabled || !isVendorEnabled('accessControlSystemFormGroup', 'isReplacementVendorChecked')"></si-combo-box>
                        </div>
                    </div>
                    <div class="row bottomPadding access-control-vendor-row">
                        <div class="col-sm-3">
                            <si-check-box formControlName="isExpansionVendorChecked" [isReadMode]="isReadMode"
                                [isDisabled]="isDisabled || !isSectionChecked('accessControlSystemFormGroup')">
                            </si-check-box>
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.ACCESS_CONTROL_SYSTEM.EXPANSION'
                                |translate}}</mat-label>
                        </div>
                        <div class="col-sm-3">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.ACCESS_CONTROL_SYSTEM.VENDOR'
                                |translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <si-combo-box [inputValue]="formControlsValueForString(accessControlSystemFormGroup,'expansionVendor')" (inputValueChange)="setFormControlValue(accessControlSystemFormGroup, 'expansionVendor', $event)"
                                [isReadMode]="isReadMode" [dropDownList]="vendorList"
                                [isDisabled]="isDisabled || !isVendorEnabled('accessControlSystemFormGroup', 'isExpansionVendorChecked')"></si-combo-box>
                        </div>
                    </div>

                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.ACCESS_CONTROL_SYSTEM.DETAILED_DRAWINGS_INCLUDED_IN_RFQ'
                                |translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                                formControlName="detailedDrawings" [disabled]="isReadMode">
                                <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(accessControlSystemFormGroup, 'detailedDrawings')">
                                </si-radio-button>
                                <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(accessControlSystemFormGroup, 'detailedDrawings')">
                                </si-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>

                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.ACCESS_CONTROL_SYSTEM.FIRM_ELECTRICAL_QUOTE'
                                |translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                                formControlName="firmElectricalQuote" [disabled]="isReadMode">
                                <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(accessControlSystemFormGroup, 'firmElectricalQuote')">
                                </si-radio-button>
                                <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(accessControlSystemFormGroup, 'firmElectricalQuote')">
                                </si-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>

                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.ACCESS_CONTROL_SYSTEM.NETWORK_PROVIDED_BY'
                                |translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            
                            <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                                formControlName="networkProvidedBy" [disabled]="isReadMode">
                                <si-radio-button [displayText]="'SIEMENS' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(accessControlSystemFormGroup, 'networkProvidedBy')">
                                </si-radio-button>
                                <si-radio-button [displayText]="'CUSTOMER' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(accessControlSystemFormGroup, 'networkProvidedBy')">
                                </si-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>

                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.ACCESS_CONTROL_SYSTEM.SERVER_PROVIDED_BY'
                                |translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <mat-radio-group
                                class="radio-group radio-btns d-flex flex-row margin-top-10" formControlName="serverProvidedBy" [disabled]="isReadMode">
                                <si-radio-button [displayText]="'SIEMENS' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(accessControlSystemFormGroup, 'serverProvidedBy')">
                                </si-radio-button>
                                <si-radio-button [displayText]="'CUSTOMER' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(accessControlSystemFormGroup, 'serverProvidedBy')">
                                </si-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>

                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.ACCESS_CONTROL_SYSTEM.INTEGRATION_WITH_OTHER_SYSTEM'
                                |translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                                formControlName="clientComputer" [disabled]="isReadMode">
                                <si-radio-button [displayText]="'SIEMENS' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(accessControlSystemFormGroup, 'clientComputer')">
                                </si-radio-button>
                                <si-radio-button [displayText]="'CUSTOMER' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(accessControlSystemFormGroup, 'clientComputer')">
                                </si-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.ACCESS_CONTROL_SYSTEM.NUMBER_OF_CLIENTS'
                                |translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <app-si-form-field [inputValue]="formControlsValueForString(accessControlSystemFormGroup,'numberOfClients')"
                              [maxlength]="40"
                                [isReadMode]="isReadMode" [isDisabled]="isDisabled">
                            </app-si-form-field>
                        </div>
                    </div>
                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.ACCESS_CONTROL_SYSTEM.RISK'
                                |translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <si-text-area formControlName="risk" [isReadMode]="isReadMode" [isDisabled]="isDisabled"
                                ></si-text-area>
                        </div>
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.ACCESS_CONTROL_SYSTEM.NUMBER_OF_PANELS'
                                |translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <app-si-form-field formControlName="numberOfPanels" 
                             [type]="'number'" [maxlength]="4" [max]="9999"
                                [isReadMode]="isReadMode" [isDisabled]="isDisabled">
                            </app-si-form-field>
                        </div>
                    </div>
                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.ACCESS_CONTROL_SYSTEM.NUMBER_OF_READERS'
                                |translate}}</mat-label>
                        </div>

                        <div class="col-sm-6">
                            <app-si-form-field formControlName="numberOfReaders"  [type]="'number'" [maxlength]="4" [max]="9999"
                                [isReadMode]="isReadMode" [isDisabled]="isDisabled">
                            </app-si-form-field>
                        </div>
                    </div>
                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.ACCESS_CONTROL_SYSTEM.NUMBER_OF_CONTACTS'
                                |translate}}</mat-label>
                        </div>

                        <div class="col-sm-6">
                            <app-si-form-field formControlName="numberOfContacts"  [type]="'number'" [maxlength]="4" [max]="9999"
                                [isReadMode]="isReadMode" [isDisabled]="isDisabled">
                            </app-si-form-field>
                        </div>
                    </div>
                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.ACCESS_CONTROL_SYSTEM.NUMBER_OF_REX'
                                |translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <app-si-form-field formControlName="numberOfREX"  [type]="'number'" [maxlength]="4" [max]="9999"

                                [isReadMode]="isReadMode" [isDisabled]="isDisabled">
                            </app-si-form-field>
                        </div>
                    </div>

                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.ACCESS_CONTROL_SYSTEM.DOOR_HARDWARE_TYPE'
                                |translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <div class="aligned-options-container">
                            <si-check-box-group
                                [options]="doorHardwareTypeOptions"
                                [isReadMode]="isReadMode"
                                [isDisabled]="isDisabled"
                                formControlName="doorHardwareType"
                                [singleRow]="true" [columnsPerRow]="2">
                            </si-check-box-group></div>
                        </div>
                    </div>

                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.ACCESS_CONTROL_SYSTEM.DOOR_HARDWARE_PROVIDED_BY'
                                |translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <div class="aligned-options-container">
                            <mat-radio-group class="radio-group radio-btns three-radio-btn margin-top-10" formControlName="doorHardwareProvidedBy" [disabled]="isReadMode">
                                <si-radio-button [displayText]="'SIEMENS' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(accessControlSystemFormGroup, 'doorHardwareProvidedBy')">
                                </si-radio-button>
                                <si-radio-button [displayText]="'SUBCONTRACTOR' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(accessControlSystemFormGroup, 'doorHardwareProvidedBy')"></si-radio-button>
                                <si-radio-button [displayText]="'OTHER' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(accessControlSystemFormGroup, 'doorHardwareProvidedBy')">
                                </si-radio-button>
                            </mat-radio-group></div>
                        </div>
                    </div>

                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.ACCESS_CONTROL_SYSTEM.DOOR_HARDWARE_INSTALLED_BY'
                                |translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <mat-radio-group class="radio-group radio-btns three-radio-btn margin-top-10" formControlName="doorHardwareInstalledBy" [disabled]="isReadMode">
                                <si-radio-button [displayText]="'SIEMENS' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(accessControlSystemFormGroup, 'doorHardwareInstalledBy')">
                                </si-radio-button>
                                <si-radio-button [displayText]="'SUBCONTRACTOR' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(accessControlSystemFormGroup, 'doorHardwareInstalledBy')"></si-radio-button>
                                <si-radio-button [displayText]="'OTHER' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(accessControlSystemFormGroup, 'doorHardwareInstalledBy')">
                                </si-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>

                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.ACCESS_CONTROL_SYSTEM.NUMBER_OF_DOORS'
                                |translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <app-si-form-field formControlName="numberOfDoors"  [type]="'number'" [maxlength]="4" [max]="9999"
                                [isReadMode]="isReadMode" [isDisabled]="isDisabled">
                            </app-si-form-field>
                        </div>
                    </div>

                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.ACCESS_CONTROL_SYSTEM.LOCAL_DOOR_ALARMS'
                                |translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <app-si-form-field formControlName="localDoorAlarms"  [maxlength]="4" [max]="9999" [type]="'number'"
                                [isReadMode]="isReadMode" [isDisabled]="isDisabled">
                            </app-si-form-field>
                        </div>
                    </div>
                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.ACCESS_CONTROL_SYSTEM.EMPLOYEES_TO_TRAIN'
                                |translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <app-si-form-field formControlName="employeesToTrain"  [type]="'number'" [maxlength]="4" [max]="9999"
                                [isReadMode]="isReadMode" [isDisabled]="isDisabled">
                            </app-si-form-field>
                        </div>
                    </div>
                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.ACCESS_CONTROL_SYSTEM.LOW_CONTRACTOR'
                                |translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <app-si-form-field formControlName="lowContractor"  [maxlength]="40"
                                [isReadMode]="isReadMode" [isDisabled]="isDisabled">
                            </app-si-form-field>
                        </div>
                    </div>
                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.ACCESS_CONTROL_SYSTEM.NUMBER_OF_BIDDERS'
                                |translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <app-si-form-field formControlName="numberOfBidders"  [type]="'number'" [maxlength]="4" [max]="9999"
                                [isReadMode]="isReadMode" [isDisabled]="isDisabled">
                            </app-si-form-field>
                        </div>
                    </div>
                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.ACCESS_CONTROL_SYSTEM.WIRE_SPEND'
                                |translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <mat-radio-group class="radio-group radio-btns d-flex flex-row" formControlName="wireSpend"
                                [disabled]="isReadMode">
                                <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(accessControlSystemFormGroup, 'wireSpend')">
                                </si-radio-button>
                                <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(accessControlSystemFormGroup, 'wireSpend')">
                                </si-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.ACCESS_CONTROL_SYSTEM.THIRD_PARTY_COMMODITY'
                                |translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                                formControlName="thirdPartyCommodity" [disabled]="isReadMode">
                                <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(accessControlSystemFormGroup, 'thirdPartyCommodity')">
                                </si-radio-button>
                                <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(accessControlSystemFormGroup, 'thirdPartyCommodity')">
                                </si-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                </div>
            </div>
        </fieldset>
        <fieldset class="border rounded-3 p-1"
            *ngIf="!costReviewSecurityEnUsAccessControlSystems?.isAccessSystemChecked && isReadMode">
            <legend class="float-none w-auto   font-size-13">
                {{'REVIEW_SOL_CHECKLIST_TAB.ACCESS_CONTROL_SYSTEM.TITLE' |translate}}</legend>
            <div class="row bottomPadding">
                <div class="col-sm-12">
                    <span> {{'REVIEW_SOL_CHECKLIST_TAB.SECTION_NOT_APPLICABLE' | translate}}</span>
                </div>
            </div>
        </fieldset>
    </div>
</div>

<!-- CCTV Systems -->
<div class="row pe-12 ps-12"
    *ngIf="(isSecurity) && costReviewSecurityEnUsCctvSystems">
    <div class="container-fluid">
        <fieldset class="border rounded-3 p-1" *ngIf="cctvSystemsFormGroup"
            [formGroup]="cctvSystemsFormGroup" [class.section-disabled]="isSectionFieldsetDisabled('cctvSystemsFormGroup')" trackChanges>
            <legend class="float-none w-auto   font-size-13">{{'REVIEW_SOL_CHECKLIST_TAB.CCTV_SYSTEM.TITLE'
                |translate}} <si-check-box [isReadMode]="false" [isDisabled]="isDisabled" [isChecked]="isSectionChecked('cctvSystemsFormGroup')" (change)="onSectionToggle('cctvSystemsFormGroup', $event)"></si-check-box></legend>
            <div class="row">
                <div class="col-sm-6">
                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.CCTV_SYSTEM.INTEGRATION_WITH_OTHER_SYSTEM'
                                |translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                                formControlName="integrationWithOtherSystems" [disabled]="isReadMode">
                                <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(cctvSystemsFormGroup, 'integrationWithOtherSystems')">
                                </si-radio-button>
                                <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(cctvSystemsFormGroup, 'integrationWithOtherSystems')">
                                </si-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                    <div class="row bottomPadding access-control-vendor-row">
                        <div class="col-sm-3">
                            <si-check-box formControlName="isNewVendorChecked" [isReadMode]="isReadMode"
                                [isDisabled]="isDisabled || !isSectionChecked('cctvSystemsFormGroup')">
                            </si-check-box>
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.CCTV_SYSTEM.NEW' |translate}}</mat-label>
                        </div>
                        <div class="col-sm-3">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.CCTV_SYSTEM.VENDOR' |translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <si-combo-box
                                [inputValue]="formControlsValueForString(cctvSystemsFormGroup,'newVendor')" (inputValueChange)="setFormControlValue(cctvSystemsFormGroup, 'newVendor', $event)"
                                [isReadMode]="isReadMode" [dropDownList]="cctvVendorList" [isDisabled]="isDisabled || !isVendorEnabled('cctvSystemsFormGroup', 'isNewVendorChecked')"></si-combo-box>
                        </div>
                    </div>
                    <div class="row bottomPadding access-control-vendor-row">
                        <div class="col-sm-3">
                            <si-check-box formControlName="isReplacementVendorChecked" [isReadMode]="isReadMode"
                                [isDisabled]="isDisabled || !isSectionChecked('cctvSystemsFormGroup')">
                            </si-check-box>
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.CCTV_SYSTEM.REPLACEMENT' |translate}}</mat-label>
                        </div>
                        <div class="col-sm-3">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.CCTV_SYSTEM.VENDOR' |translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <si-combo-box
                                [inputValue]="formControlsValueForString(cctvSystemsFormGroup,'replacementVendor')" (inputValueChange)="setFormControlValue(cctvSystemsFormGroup, 'replacementVendor', $event)"
                                [isReadMode]="isReadMode" [dropDownList]="cctvVendorList" [isDisabled]="isDisabled || !isVendorEnabled('cctvSystemsFormGroup', 'isReplacementVendorChecked')"></si-combo-box>
                        </div>
                    </div>
                    <div class="row bottomPadding access-control-vendor-row">
                        <div class="col-sm-3">
                            <si-check-box formControlName="isExpansionVendorChecked" [isReadMode]="isReadMode"
                                [isDisabled]="isDisabled || !isSectionChecked('cctvSystemsFormGroup')">
                            </si-check-box>
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.CCTV_SYSTEM.EXPANSION' |translate}}</mat-label>
                        </div>
                        <div class="col-sm-3">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.CCTV_SYSTEM.VENDOR' |translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <si-combo-box
                                [inputValue]="formControlsValueForString(cctvSystemsFormGroup,'expansionVendor')" (inputValueChange)="setFormControlValue(cctvSystemsFormGroup, 'expansionVendor', $event)"
                                [isReadMode]="isReadMode" [dropDownList]="cctvVendorList" [isDisabled]="isDisabled || !isVendorEnabled('cctvSystemsFormGroup', 'isExpansionVendorChecked')"></si-combo-box>
                        </div>
                    </div>

                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.CCTV_SYSTEM.SERVER_PROVIDED_BY'
                                |translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <mat-radio-group class="radio-group radio-btns d-flex flex-row margin-top-10" formControlName="serverProvidedBy" [disabled]="isReadMode">
                                <si-radio-button [displayText]="'SIEMENS' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(cctvSystemsFormGroup, 'serverProvidedBy')">
                                </si-radio-button>
                                <si-radio-button [displayText]="'CUSTOMER' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(cctvSystemsFormGroup, 'serverProvidedBy')">
                                </si-radio-button>
                            </mat-radio-group>  
                        </div>
                    </div>

                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.CCTV_SYSTEM.STORAGE_PROVIDED_BY'
                                |translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <mat-radio-group class="radio-group radio-btns d-flex flex-row margin-top-10" formControlName="storageProvidedBy" [disabled]="isReadMode">
                                <si-radio-button [displayText]="'SIEMENS' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(cctvSystemsFormGroup, 'storageProvidedBy')">
                                </si-radio-button>
                                <si-radio-button [displayText]="'CUSTOMER' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(cctvSystemsFormGroup, 'storageProvidedBy')">
                                </si-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>

                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.CCTV_SYSTEM.CLIENT_COMPUTER_PROVIDED_BY'
                                |translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <mat-radio-group class="radio-group radio-btns d-flex flex-row margin-top-10" formControlName="clientComputer" [disabled]="isReadMode">
                                <si-radio-button [displayText]="'SIEMENS' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(cctvSystemsFormGroup, 'clientComputer')">
                                </si-radio-button>
                                <si-radio-button [displayText]="'CUSTOMER' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(cctvSystemsFormGroup, 'clientComputer')">
                                </si-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>

                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.CCTV_SYSTEM.NUMBER_OF_CLIENTS'
                                |translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <app-si-form-field formControlName="numberOfClients"  [type]="'number'" [maxlength]="2" [max]="99"
                                [isReadMode]="isReadMode" [isDisabled]="isDisabled">
                            </app-si-form-field>
                        </div>
                    </div>

                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.CCTV_SYSTEM.INTEGRATION_REQUIRED'
                                |translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <div class="aligned-options-container">
                            <si-check-box-group
                                [options]="cctvIntegrationRequiredOptions"
                                [isReadMode]="isReadMode"
                                [isDisabled]="isDisabled"
                                formControlName="integrationRequired"
                                [singleRow]="true" [columnsPerRow]="2">
                            </si-check-box-group></div>
                        </div>
                        <div class="col-sm-2"></div>
                    </div>
                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.CCTV_SYSTEM.LIFT_REQUIRED'
                                |translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <div class="aligned-options-container">
                            <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                                formControlName="liftRequired" [disabled]="isReadMode">
                                <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(cctvSystemsFormGroup, 'liftRequired')">
                                </si-radio-button>
                                <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(cctvSystemsFormGroup, 'liftRequired')">
                                </si-radio-button>
                            </mat-radio-group></div>
                        </div>
                    </div>
                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.CCTV_SYSTEM.RISK' |translate}}</mat-label>
                        </div>
                        <div class="col-sm-6 mb-3">
                            <si-text-area formControlName="risk" [isReadMode]="isReadMode" [isDisabled]="isDisabled"
                                ></si-text-area>
                        </div>
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.CCTV_SYSTEM.NUMBER_OF_CONTROLLERS'
                                |translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <app-si-form-field formControlName="numberOfControllers"  [type]="'number'" [maxlength]="4" [max]="9999"
                                [isReadMode]="isReadMode" [isDisabled]="isDisabled">
                            </app-si-form-field>
                        </div>
                    </div>
                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.CCTV_SYSTEM.NUMBER_OF_INSIDE_CAMERAS'
                                |translate}}</mat-label>
                        </div>

                        <div class="col-sm-6">
                            <app-si-form-field formControlName="numberOfInsideCameras"  [type]="'number'" [maxlength]="4" [max]="9999"
                                [isReadMode]="isReadMode" [isDisabled]="isDisabled">
                            </app-si-form-field>
                        </div>
                    </div>
                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.CCTV_SYSTEM.NUMBER_OF_OUTSIDE_CAMERAS'
                                |translate}}</mat-label>
                        </div>

                        <div class="col-sm-6">
                            <app-si-form-field formControlName="numberOfOutsideCameras"  [type]="'number'" [maxlength]="4" [max]="9999"
                                [isReadMode]="isReadMode" [isDisabled]="isDisabled">
                            </app-si-form-field>
                        </div>
                    </div>
                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.CCTV_SYSTEM.NUMBER_OF_PAN_AND_TILT_CAMERAS'
                                |translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <app-si-form-field formControlName="panAndTiltCameras"  [type]="'number'" [maxlength]="4" [max]="9999"
                                [isReadMode]="isReadMode" [isDisabled]="isDisabled">
                            </app-si-form-field>
                        </div>
                    </div>

                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.CCTV_SYSTEM.EXPECTED_STORAGE_TIME'
                                |translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <app-si-form-field formControlName="expectedStorageTime"  [maxlength]="40"
                                [isReadMode]="isReadMode" [isDisabled]="isDisabled">
                            </app-si-form-field>
                        </div>
                    </div>

                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.CCTV_SYSTEM.ARCHIVING_MEDIA'
                                |translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                                formControlName="archivingMedia" [disabled]="isReadMode">
                                <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(cctvSystemsFormGroup, 'archivingMedia')">
                                </si-radio-button>
                                <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(cctvSystemsFormGroup, 'archivingMedia')">
                                </si-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>

                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.CCTV_SYSTEM.NUMBER_OF_EMPLOYEES_TO_TRAIN'
                                |translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <app-si-form-field formControlName="employeesToTrain"  [type]="'number'" [maxlength]="4" [max]="9999"
                                [isReadMode]="isReadMode" [isDisabled]="isDisabled">
                            </app-si-form-field>
                        </div>
                    </div>

                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.CCTV_SYSTEM.LOW_CONTRACTOR'
                                |translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <app-si-form-field formControlName="lowContractor"  [maxlength]="40"
                                [isReadMode]="isReadMode" [isDisabled]="isDisabled">
                            </app-si-form-field>
                        </div>
                    </div>

                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.CCTV_SYSTEM.NUMBER_OF_BIDDERS'
                                |translate}}s</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <app-si-form-field formControlName="numberOfBidders"  [type]="'number'" [maxlength]="4" [max]="9999"
                                [isReadMode]="isReadMode" [isDisabled]="isDisabled">
                            </app-si-form-field>
                        </div>
                    </div>
                </div>
            </div>
        </fieldset>
        <fieldset class="border rounded-3 p-1" *ngIf="!costReviewSecurityEnUsCctvSystems?.isCCTVSystemsChecked && isReadMode">
            <legend class="float-none w-auto   font-size-13">{{'REVIEW_SOL_CHECKLIST_TAB.CCTV_SYSTEM.TITLE'
                |translate}}</legend>
            <div class="row bottomPadding">
                <div class="col-sm-12">
                    <span> {{'REVIEW_SOL_CHECKLIST_TAB.SECTION_NOT_APPLICABLE' | translate}}</span>
                </div>
            </div>
        </fieldset>
    </div>
</div>

<!-- Intercom System -->
<div class="row pe-12 ps-12"
    *ngIf="(isSecurity) && costReviewSecurityEnUsIntercomSystem">
    <div class="container-fluid">
        <fieldset class="border rounded-3 p-1" *ngIf="intercomSystemFormGroup"
            [formGroup]="intercomSystemFormGroup" [class.section-disabled]="isSectionFieldsetDisabled('intercomSystemFormGroup')" trackChanges>
            <legend class="float-none w-auto   font-size-13">
                {{'REVIEW_SOL_CHECKLIST_TAB.INTERCOM_SYSTEM.TITLE' | translate}} <si-check-box  [isReadMode]="false" [isDisabled]="isDisabled" [isChecked]="isSectionChecked('intercomSystemFormGroup')" (change)="onSectionToggle('intercomSystemFormGroup', $event)"></si-check-box></legend>
            <div class="row">
                <div class="col-sm-6">
                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.INTERCOM_SYSTEM.INTEGRATION_WITH_OTHER_SYSTEM' |
                                translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                                formControlName="integrationWithOtherSystems" [disabled]="isReadMode">
                                <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(intercomSystemFormGroup, 'integrationWithOtherSystems')">
                                </si-radio-button>
                                <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(intercomSystemFormGroup, 'integrationWithOtherSystems')">
                                </si-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                    <div class="row bottomPadding access-control-vendor-row">
                        <div class="col-sm-3">
                            <si-check-box formControlName="isNewVendorChecked" [isReadMode]="isReadMode"
                                [isDisabled]="isDisabled || !isSectionChecked('intercomSystemFormGroup')">
                            </si-check-box>
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.INTERCOM_SYSTEM.NEW' | translate}}</mat-label>
                        </div>
                        <div class="col-sm-3">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.INTERCOM_SYSTEM.VENDOR' | translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <app-si-form-field formControlName="newVendor"  [maxlength]="40"
                                [isReadMode]="isReadMode" [isDisabled]="isDisabled || !isVendorEnabled('intercomSystemFormGroup', 'isNewVendorChecked')">
                            </app-si-form-field>
                        </div>
                    </div>
                    <div class="row bottomPadding access-control-vendor-row">
                        <div class="col-sm-3">
                            <si-check-box formControlName="isReplacementVendorChecked" [isReadMode]="isReadMode"
                                [isDisabled]="isDisabled || !isSectionChecked('intercomSystemFormGroup')">
                            </si-check-box>
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.INTERCOM_SYSTEM.REPLACEMENT' |
                                translate}}</mat-label>
                        </div>
                        <div class="col-sm-3">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.INTERCOM_SYSTEM.VENDOR' | translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <app-si-form-field formControlName="replacementVendor"  [maxlength]="40"
                                [isReadMode]="isReadMode" [isDisabled]="isDisabled || !isVendorEnabled('intercomSystemFormGroup', 'isReplacementVendorChecked')">
                            </app-si-form-field>
                        </div>
                    </div>
                    <div class="row bottomPadding access-control-vendor-row">
                        <div class="col-sm-3">
                            <si-check-box formControlName="isExpansionVendorChecked" [isReadMode]="isReadMode"
                                [isDisabled]="isDisabled || !isSectionChecked('intercomSystemFormGroup')">
                            </si-check-box>
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.INTERCOM_SYSTEM.EXPANSION' |
                                translate}}</mat-label>
                        </div>
                        <div class="col-sm-3">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.INTERCOM_SYSTEM.VENDOR' | translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <app-si-form-field formControlName="expansionVendor"  [maxlength]="40"
                                [isReadMode]="isReadMode" [isDisabled]="isDisabled || !isVendorEnabled('intercomSystemFormGroup', 'isExpansionVendorChecked')">
                            </app-si-form-field>
                        </div>
                    </div>
                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.INTERCOM_SYSTEM.RISK' | translate}}</mat-label>
                        </div>
                        <div class="col-sm-6 mb-2">
                            <si-text-area formControlName="risk" [isReadMode]="isReadMode" [isDisabled]="isDisabled"
                                ></si-text-area>   
                        </div>
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.INTERCOM_SYSTEM.NUMBER_OF_MASTERS' |
                                translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <app-si-form-field formControlName="numberOfMasters"  [type]="'number'" [maxlength]="4" [max]="9999"
                                [isReadMode]="isReadMode" [isDisabled]="isDisabled">
                            </app-si-form-field>
                        </div>
                    </div>
                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.INTERCOM_SYSTEM.NUMBER_OF_SUBSTATIONS' |
                                translate}}</mat-label>
                        </div>

                        <div class="col-sm-6">
                            <app-si-form-field formControlName="numberOfSubstations"  [type]="'number'" [maxlength]="4" [max]="9999"
                                [isReadMode]="isReadMode" [isDisabled]="isDisabled">
                            </app-si-form-field>
                        </div>
                    </div>
                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.INTERCOM_SYSTEM.EMPLOYEES_TO_TRAIN' |
                                translate}}</mat-label>
                        </div>

                        <div class="col-sm-6">
                            <app-si-form-field formControlName="employeesToTrain"  [type]="'number'" [maxlength]="4" [max]="9999"
                                [isReadMode]="isReadMode" [isDisabled]="isDisabled">
                            </app-si-form-field>
                        </div>
                    </div>
                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.INTERCOM_SYSTEM.LOW_CONTRACTOR' |
                                translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <app-si-form-field formControlName="lowContractor"  [maxlength]="40"
                                [isReadMode]="isReadMode" [isDisabled]="isDisabled">
                            </app-si-form-field>
                        </div>
                    </div>

                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.INTERCOM_SYSTEM.NUMBER_OF_BIDDERS' |
                                translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <app-si-form-field formControlName="numberOfBidders"  [type]="'number'" [maxlength]="4" [max]="9999"
                                [isReadMode]="isReadMode" [isDisabled]="isDisabled">
                            </app-si-form-field>
                        </div>
                    </div>
                </div>
            </div>
        </fieldset>
        <fieldset class="border rounded-3 p-1" *ngIf="!costReviewSecurityEnUsIntercomSystem?.isIntercomSystemChecked && isReadMode">
            <legend class="float-none w-auto   font-size-13">
                {{'REVIEW_SOL_CHECKLIST_TAB.INTERCOM_SYSTEM.TITLE' | translate}}</legend>
            <div class="row bottomPadding">
                <div class="col-sm-12">
                    <span> {{'REVIEW_SOL_CHECKLIST_TAB.SECTION_NOT_APPLICABLE' | translate}}</span>
                </div>
            </div>
        </fieldset>
    </div>
</div>

<!-- Intrusion System -->
<div class="row pe-12 ps-12"
    *ngIf="(isSecurity) && costReviewSecurityEnUsIntrusionSystem">
    <div class="container-fluid">
        <fieldset class="border rounded-3 p-1" *ngIf="intrusionSystemFormGroup"
            [formGroup]="intrusionSystemFormGroup" [class.section-disabled]="isSectionFieldsetDisabled('intrusionSystemFormGroup')" trackChanges>
            <legend class="float-none w-auto   font-size-13">
                {{'REVIEW_SOL_CHECKLIST_TAB.INTRUSION_SYSTEM.TITLE' | translate}} <si-check-box  [isReadMode]="false" [isDisabled]="isDisabled" [isChecked]="isSectionChecked('intrusionSystemFormGroup')" (change)="onSectionToggle('intrusionSystemFormGroup', $event)"></si-check-box></legend>
            <div class="row">
                <div class="col-sm-6">
                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.INTRUSION_SYSTEM.INTEGRATION_WITH_OTHER_SYSTEM' |
                                translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                                formControlName="integrationWithOtherSystems" [disabled]="isReadMode">
                                <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(intrusionSystemFormGroup, 'integrationWithOtherSystems')">
                                </si-radio-button>
                                <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(intrusionSystemFormGroup, 'integrationWithOtherSystems')">
                                </si-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                    <div class="row bottomPadding access-control-vendor-row">
                        <div class="col-sm-3">
                            <si-check-box formControlName="isNewVendorChecked" [isReadMode]="isReadMode"
                                [isDisabled]="isDisabled || !isSectionChecked('intrusionSystemFormGroup')">
                            </si-check-box>
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.INTRUSION_SYSTEM.NEW' | translate}}</mat-label>
                        </div>
                        <div class="col-sm-3">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.INTRUSION_SYSTEM.VENDOR' |
                                translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                             <si-combo-box
                                [inputValue]="formControlsValueForString(intrusionSystemFormGroup,'newVendor')"
                                          (inputValueChange)="setFormControlValue(intrusionSystemFormGroup, 'newVendor', $event)"
                                [isReadMode]="isReadMode" [dropDownList]="intrusionSystemList" [isDisabled]="isDisabled || !isVendorEnabled('intrusionSystemFormGroup', 'isNewVendorChecked')">
                            </si-combo-box>
                        </div>
                    </div>
                    <div class="row bottomPadding access-control-vendor-row">
                        <div class="col-sm-3">
                            <si-check-box formControlName="isReplacementVendorChecked" [isReadMode]="isReadMode"
                                [isDisabled]="isDisabled || !isSectionChecked('intrusionSystemFormGroup')">
                            </si-check-box>
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.INTRUSION_SYSTEM.REPLACEMENT' |
                                translate}}</mat-label>
                        </div>
                        <div class="col-sm-3">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.INTRUSION_SYSTEM.VENDOR' |
                                translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <si-combo-box
                                [inputValue]="formControlsValueForString(intrusionSystemFormGroup,'replacementVendor')"
                                (inputValueChange)="setFormControlValue(intrusionSystemFormGroup, 'replacementVendor', $event)"
                                [isReadMode]="isReadMode" [dropDownList]="intrusionSystemList" [isDisabled]="isDisabled || !isVendorEnabled('intrusionSystemFormGroup', 'isReplacementVendorChecked')">
                            </si-combo-box>
                        </div>
                    </div>
                    <div class="row bottomPadding access-control-vendor-row">
                        <div class="col-sm-3">
                            <si-check-box formControlName="isExpansionVendorChecked" [isReadMode]="isReadMode"
                                [isDisabled]="isDisabled || !isSectionChecked('intrusionSystemFormGroup')">
                            </si-check-box>
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.INTRUSION_SYSTEM.EXPANSION' |
                                translate}}</mat-label>
                        </div>
                        <div class="col-sm-3">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.INTRUSION_SYSTEM.VENDOR' |
                                translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <si-combo-box
                                [inputValue]="formControlsValueForString(intrusionSystemFormGroup,'expansionVendor')"
                                (inputValueChange)="setFormControlValue(intrusionSystemFormGroup, 'expansionVendor', $event)"
                                [isReadMode]="isReadMode" [dropDownList]="intrusionSystemList" [isDisabled]="isDisabled || !isVendorEnabled('intrusionSystemFormGroup', 'isExpansionVendorChecked')">
                            </si-combo-box>
                        </div>
                    </div>
                    <div class="row bottomPadding access-control-vendor-row">
                        <div class="col-sm-3">
                            <si-check-box formControlName="isMonitoringVendorChecked" [isReadMode]="isReadMode"
                                [isDisabled]="isDisabled || !isSectionChecked('intrusionSystemFormGroup')">
                            </si-check-box>
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.INTRUSION_SYSTEM.MONITORING' |
                                translate}}</mat-label>
                        </div>
                        <div class="col-sm-3">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.INTRUSION_SYSTEM.VENDOR' |
                                translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <si-combo-box
                                [inputValue]="formControlsValueForString(intrusionSystemFormGroup,'monitoringVendor')"
                                (inputValueChange)="setFormControlValue(intrusionSystemFormGroup, 'monitoringVendor', $event)"
                                [isReadMode]="isReadMode" [dropDownList]="intrusionSystemList" [isDisabled]="isDisabled || !isVendorEnabled('intrusionSystemFormGroup', 'isMonitoringVendorChecked')">
                            </si-combo-box>
                        </div>
                    </div>
                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.INTRUSION_SYSTEM.DETAILED_DRAWINGS_INCLUDED_IN_RFQ'
                                | translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                                formControlName="detailedDrawings" [disabled]="isReadMode">
                                <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(intrusionSystemFormGroup, 'detailedDrawings')">
                                </si-radio-button>
                                <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(intrusionSystemFormGroup, 'detailedDrawings')">
                                </si-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.INTRUSION_SYSTEM.LIFT_REQUIRED' |
                                translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                                formControlName="liftRequired" [disabled]="isReadMode">
                                <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(intrusionSystemFormGroup, 'liftRequired')">
                                </si-radio-button>
                                <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(intrusionSystemFormGroup, 'liftRequired')">
                                </si-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.INTRUSION_SYSTEM.RISK' | translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <si-text-area formControlName="risk" [isDisabled]="isDisabled"
                                [isReadMode]="isReadMode"></si-text-area>
                        </div>
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.INTRUSION_SYSTEM.NUMBER_OF_PANELS' |
                                translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <app-si-form-field formControlName="numberOfPanels"  [type]="'number'" [maxlength]="4" [max]="9999"
                                [isReadMode]="isReadMode" [isDisabled]="isDisabled">
                            </app-si-form-field>
                        </div>
                    </div>
                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.INTRUSION_SYSTEM.NUMBER_OF_KEYPADS' |
                                translate}}</mat-label>
                        </div>

                        <div class="col-sm-6">
                            <app-si-form-field formControlName="numberOfKeypads"  [type]="'number'" [maxlength]="4" [max]="9999"
                                [isReadMode]="isReadMode" [isDisabled]="isDisabled">
                            </app-si-form-field>
                        </div>
                    </div>
                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.INTRUSION_SYSTEM.NUMBER_OF_CONTACTS' |
                                translate}}</mat-label>
                        </div>

                        <div class="col-sm-6">
                            <app-si-form-field formControlName="numberOfContacts"  [type]="'number'" [maxlength]="4" [max]="9999"
                                [isReadMode]="isReadMode" [isDisabled]="isDisabled">
                            </app-si-form-field>
                        </div>
                    </div>
                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.INTRUSION_SYSTEM.NUMBER_OF_MOTION_DETECTORS' |
                                translate}}</mat-label>
                        </div>

                        <div class="col-sm-6">
                            <app-si-form-field formControlName="numberOfMotionDetectors"  [type]="'number'" [maxlength]="4" [max]="9999"
                                [isReadMode]="isReadMode" [isDisabled]="isDisabled">
                            </app-si-form-field>
                        </div>
                    </div>
                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.INTRUSION_SYSTEM.NUMBER_OF_LOCAL_AUDIBLE_DEVICES'
                                | translate}}</mat-label>
                        </div>

                        <div class="col-sm-6">
                            <app-si-form-field formControlName="localAudibleDevices"  [maxlength]="40"
                                [isReadMode]="isReadMode" [isDisabled]="isDisabled">
                            </app-si-form-field>
                        </div>
                    </div>
                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.INTRUSION_SYSTEM.EMPLOYEES_TO_TRAIN' |
                                translate}}</mat-label>
                        </div>

                        <div class="col-sm-6">
                            <app-si-form-field formControlName="employeesToTrain"  [type]="'number'" [maxlength]="4" [max]="9999"
                                [isReadMode]="isReadMode" [isDisabled]="isDisabled">
                            </app-si-form-field>
                        </div>
                    </div>
                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.INTRUSION_SYSTEM.LOW_CONTRACTOR' |
                                translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <app-si-form-field formControlName="lowContractor"  [maxlength]="40"
                                [isReadMode]="isReadMode" [isDisabled]="isDisabled">
                            </app-si-form-field>
                        </div>
                    </div>

                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.INTRUSION_SYSTEM.NUMBER_OF_BIDDERS' |
                                translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <app-si-form-field formControlName="numberOfBidders"  [type]="'number'" [maxlength]="4" [max]="9999"
                                [isReadMode]="isReadMode" [isDisabled]="isDisabled">
                            </app-si-form-field>
                        </div>
                    </div>
                </div>
            </div>
        </fieldset>
        <fieldset class="border rounded-3 p-1" *ngIf="!costReviewSecurityEnUsIntrusionSystem?.isIntrusionSystemChecked && isReadMode">
            <legend class="float-none w-auto   font-size-13">
                {{'REVIEW_SOL_CHECKLIST_TAB.INTRUSION_SYSTEM.TITLE' | translate}}</legend>
            <div class="row bottomPadding">
                <div class="col-sm-12">
                    <span> {{'REVIEW_SOL_CHECKLIST_TAB.SECTION_NOT_APPLICABLE' | translate}}</span>
                </div>
            </div>
        </fieldset>
    </div>
</div>







